export default __webpack_public_path__ + "static/media/background.6f50d29f.jpg";